import { render, staticRenderFns } from "./LoyalitySignupCongratulations.vue?vue&type=template&id=2b33d552&scoped=true"
import script from "./LoyalitySignupCongratulations.vue?vue&type=script&lang=js"
export * from "./LoyalitySignupCongratulations.vue?vue&type=script&lang=js"
import style0 from "./LoyalitySignupCongratulations.vue?vue&type=style&index=0&id=2b33d552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33d552",
  null
  
)

export default component.exports